export default function(state = {}, action){
    switch(action.type){
        case "SET_AGENT_CONFIG":
            return action.payload;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/getAgentConfig.js